import React from 'react';
import { STATUS } from '../state/model';
import { useDialog } from './Dialog';
import {
  getCell,
  rowTotal,
  colTotal,
  grandTotal,
  classTotals,
  AREA_CLASS_OPTIONS,
} from '../state/matrix';

function fmt(n) {
  return n ? Math.round(n).toLocaleString('he-IL') : '0';
}

// Editable floors×elements matrix. Each cell is a computational object; editing
// the area flips it to "הוזן ידנית". Totals (per row/column/class) are derived
// live so the existing-state model stays a view over the cell objects.
export default function MatrixGrid({ matrix, onCellChange, onAddRow, onAddColumn, onColClassChange }) {
  const ct = classTotals(matrix);
  const dlg = useDialog();

  const addRow = async () => {
    const label = await dlg.prompt({ title: 'הוספת מפלס / קומה', message: 'שם המפלס או הקומה', placeholder: 'לדוגמה: קומה 1, מרתף' });
    if (label && label.trim()) onAddRow(label.trim());
  };
  const addColumn = async () => {
    const label = await dlg.prompt({ title: 'הוספת רכיב שטח', message: 'שם רכיב השטח', placeholder: 'לדוגמה: מחסן, מרפסת' });
    if (label && label.trim()) onAddColumn(label.trim());
  };

  return (
    <div className="rd-matrix-wrap">
      <table className="rd-matrix">
        <thead>
          <tr>
            <th className="rd-matrix-corner">מפלס / קומה</th>
            {matrix.columns.map((col) => (
              <th key={col.id} className="rd-matrix-colhead">
                <div>{col.label}</div>
                <select
                  className="rd-matrix-class-select"
                  value={col.classification}
                  onChange={(e) => onColClassChange(col.id, e.target.value)}
                  title="סיווג שטח"
                >
                  {AREA_CLASS_OPTIONS.map((o) => (
                    <option key={o.id} value={o.id}>{o.label}</option>
                  ))}
                </select>
              </th>
            ))}
            <th className="rd-matrix-total">סה״כ</th>
          </tr>
        </thead>
        <tbody>
          {matrix.rows.map((row) => (
            <tr key={row.id}>
              <th className="rd-matrix-rowhead">{row.label || `מפלס ${row.level ?? ''}`}</th>
              {matrix.columns.map((col) => {
                const cell = getCell(matrix, row.id, col.id);
                const empty = cell.sqm == null;
                return (
                  <td key={col.id} className="rd-matrix-cell">
                    <input
                      className={`rd-cell-input ${empty ? 'is-empty' : ''} ${cell.status === STATUS.CONFLICT ? 'is-conflict' : ''}`}
                      type="number"
                      value={cell.sqm ?? ''}
                      placeholder="הזן"
                      title={cell.source ? `מקור: ${cell.source}` : 'הזן שטח במ״ר'}
                      onChange={(e) =>
                        onCellChange(row.id, col.id, e.target.value === '' ? null : Number(e.target.value))
                      }
                    />
                  </td>
                );
              })}
              <td className="rd-matrix-total">{fmt(rowTotal(matrix, row.id))}</td>
            </tr>
          ))}
          <tr className="rd-matrix-totalrow">
            <th className="rd-matrix-rowhead">סה״כ</th>
            {matrix.columns.map((col) => (
              <td key={col.id} className="rd-matrix-total">{fmt(colTotal(matrix, col.id))}</td>
            ))}
            <td className="rd-matrix-total rd-matrix-grand">{fmt(grandTotal(matrix))}</td>
          </tr>
        </tbody>
      </table>

      <div className="rd-matrix-actions">
        <button type="button" className="rd-mini-btn" onClick={addRow}>+ מפלס</button>
        <button type="button" className="rd-mini-btn" onClick={addColumn}>+ רכיב</button>
      </div>

      <div className="rd-matrix-classtotals">
        <span>עיקרי: <b>{fmt(ct.main)}</b> מ״ר</span>
        <span>שירות: <b>{fmt(ct.service)}</b> מ״ר</span>
        <span>חניה: <b>{fmt(ct.parking)}</b> מ״ר</span>
        <span>פתוח: <b>{fmt(ct.open)}</b> מ״ר</span>
        <span>לא נספר: <b>{fmt(ct.uncounted)}</b> מ״ר</span>
      </div>
    </div>
  );
}
